import { useNavigate } from "react-router-dom";
import SignIn from "@/components/Forms/SignIn";

export default function Login() {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-screen overflow-hidden">
      <SignIn onRegisterClick={() => navigate("/signup")} />
    </div>
  );
}
